
import Vue from 'vue';

import PaginatedGetter from '@/pages/search/results/table/ConcordanceGetter';
import {blacklab} from '@/api';
import { BLSearchParameters, BLHitResults, BLDocResults } from '@/types/blacklabtypes';

import { ColumnDefs, DisplaySettingsForRendering, GroupRowData, makeRows, Rows } from '@/pages/search/results/table/table-layout';

import Spinner from '@/components/Spinner.vue';
import IRow from '@/pages/search/results/table/IRow.vue';
import * as CorpusStore from '@/store/search/corpus';

export default Vue.component('GroupRowDetails', IRow.extend({
	components: {
		Spinner
	},
	// NOTE: also update the watcher on this prop if you change this name!
	props: { row: Object as () => GroupRowData },
	data: () => ({
		concordances: null as any as PaginatedGetter<Rows>,
	}),
	methods: {
		createGetter() {
			this.concordances = new PaginatedGetter((oldRows, first, number) => {
				// make a copy of the parameters so we don't clear them for all components using the summary
				const requestParameters: BLSearchParameters = Object.assign({}, this.query, {
					// Do not clear sample/samplenum/samplecount,
					// or we could retrieve concordances that weren't included in the input results for the grouping
					number,
					first,
					viewgroup: this.row.id,
					sort: CorpusStore.get.isParallelCorpus() ? 'alignments' : undefined, // if parallel corpus, show aligned hits first. (if not, we don't care about order)
				} as BLSearchParameters);

				let {request, cancel} = this.type === 'hits' ? blacklab.getHits<BLHitResults>(INDEX_ID, requestParameters) : blacklab.getDocs<BLDocResults>(INDEX_ID, requestParameters);
				return {
					cancel,
					request: request
					.then(newResults => makeRows(newResults, this.info))
					.then(newRows => {
						if (this.type === 'hits') newRows.rows = newRows.rows.filter(r => r.type === 'hit');
						else newRows.rows = newRows.rows.filter(r => r.type === 'doc');


						if (!oldRows) return newRows;
						oldRows.rows.push(...newRows.rows);
						return oldRows;
					})
				}
			}, this.row.size)
		}
	},
	watch: {
		row: {
			handler() { this.createGetter(); },
			immediate: true
		},
		open() {
			if (this.open && !this.concordances.done && !this.concordances.loading && !this.concordances.results?.rows.length) this.concordances.next();
		}
	}
}));
